<div fxLayout="column" fxLayoutAlign="start start" class="w-100">
    <af-filter class="w-100"
               [filterFields]="filterFields"
               [filterEvent]="filterEvent"
               [placeholderContext]="mode === 'documents' ? 'knowledgeDocuments' : 'faq'"
               [showImport]="false"
               [showExport]="false"
               (filterListener)="onFilterChange($event)"/>

    <mat-accordion [multi]="true" class="w-100 mt-16" fxLayout="column" fxLayoutGap="12px">
        @for (bucket of filteredBuckets; track bucket.code) {
            <mat-expansion-panel class="w-100 faq-category-panel"
                                 [hideToggle]="true"
                                 (opened)="onBucketOpened(bucket)"
                                 (closed)="onBucketClosed(bucket)">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="radius-4 bc-primary-green-100 c-primary-gray-900 pl-12 pr-12 t2-semi-bold">
                            {{ bucket.name }}
                        </div>
                    </mat-panel-title>
                    <mat-panel-description fxLayoutAlign="end center">
                        @if (Spinner.isShown(bucketSpinnerPrefix + bucket.code)) {
                            <ui-kit-spinner [diameter]="20"
                                            [strokeWidth]="3"
                                            [spinnerIds]="bucketSpinnerPrefix + bucket.code"/>
                        } @else {
                            <ui-kit-svg class="faq-category-toggle i-24" [class.expanded]="bucket.expanded" [name]="'ic_arrow_down'"/>
                        }
                    </mat-panel-description>
                </mat-expansion-panel-header>

                @if (mode === 'faq') {
                    <af-faq-answers [faqs]="$any(bucket.items)"/>
                } @else {
                    <af-knowledge-document-items [documents]="$any(bucket.items)"/>
                }
            </mat-expansion-panel>
        }
    </mat-accordion>

    <ui-kit-empty-state class="mt-24 w-100"
                        [icon]="emptyStateIcon"
                        [spinnerIds]="spinnerId"
                        [items]="filteredBuckets"
                        [title]="emptyStateTitle"
                        [subtitle]="emptyStateSubtitle"
                        backgroundColor="light"/>
</div>
